export const faceSwapeEnvOptions = {
    environment: {
      environmentAtmosphere: {
        label: '环境氛围',
        options: {
          warmSunlight: '温暖阳光',
          coolTone: '冷调',
          darkAtmosphere: '暗黑氛围',
          cloudyHazy: '阴天/雾霾环境',
          lightThroughWindow: '光线透过窗户'
        }
      },
      lightStyle: {
        label: '灯光类型',
        options: {
          naturalSunlight: '自然阳光',
          softAmbientLight: '柔和环境光',
          harshSunlight: '强烈阳光',
          overcastSky: '阴天',
          sunsetGlow: '日落余晖',
          candlelight: '烛光',
          moonlight: '月光',
          backlitSilhouette: '逆光剪影',
          spotlight: '聚光灯',
          rimLighting: '边缘光',
          studioLighting: '摄影棚灯光',
          goldenHourLight: '黄金时刻光线',
          blueHourLight: '蓝色时刻光线',
          neonLights: '霓虹灯'
        }
      },
      lightDirection: {
        label: '灯光方向',
        options: {
          fromTop: '从上方',
          fromBottom: '从下方',
          fromRight: '从右侧',
          fromLeft: '从左侧',
          fromFront: '从前方',
          fromTopRight: '从右上方',
          fromTopLeft: '从左上方'
        }
      },
      background: {
        label: '背景',
        options: {
          naturalLandscape: '自然景观',
          urbanBackground: '城市背景',
          simpleBackground: '简单背景',
          indoorBackground: '室内背景',
          virtualBackground: '虚拟背景'
        }
      },
      backgroundEffect: {
        label: '背景效果',
        options: {
          dynamicBackground: '动态背景',
          neonLightBackground: '霓虹灯背景',
          starrySkyBackground: '星空背景',
          fogMistEffect: '雾霾/雾气效果',
          minimalistBackground: '极简背景'
        }
      },
      backgroundBlur: {
        label: '背景虚化',
        options: {
          slightBlur: '轻度虚化',
          strongBlur: '强烈虚化',
          hazeEffect: '雾霾效果'
        }
      }
    }
  };
